import dataSyncService from './DataSyncService';

const SOUND_KEY = 'kmfc-sound-enabled';
const CHIME_URL = '/assets/chime.wav';

const getUrgency = (orders) => {
  const newOrders = (orders && orders.new) || [];
  if (newOrders.length === 0) return null;
  const oldestMs = newOrders.reduce((oldest, o) => {
    const t = o.placed_at ? new Date(o.placed_at).getTime() : Date.now();
    return Math.min(oldest, t);
  }, Date.now());
  const ageMin = (Date.now() - oldestMs) / 60000;
  if (ageMin >= 10) return { pause: 1000 };
  if (ageMin >= 5)  return { pause: 1500 };
  return               { pause: 2000 };
};


function playFile(url, onError) {
  return new Promise(resolve => {
    const audio = new Audio(url);
    audio.volume = 1.0;
    audio.onended = resolve;
    audio.onerror = () => { if (onError) onError(); resolve(); };
    const p = audio.play();
    if (p && p.catch) p.catch(() => { if (onError) onError(); resolve(); });
  });
}

class SoundService {
  constructor() {
    this._playing       = false;
    this._unsubscribe   = null;
    this._syncStarted   = false;
    this._currentOrders = null;
    this._nextTimer     = null;
    this._onStorageChange = this._onStorageChange.bind(this);
  }

  _isEnabled() {
    try { return JSON.parse(localStorage.getItem(SOUND_KEY) || 'false'); }
    catch { return false; }
  }

  _clearTimer() {
    if (this._nextTimer) { clearTimeout(this._nextTimer); this._nextTimer = null; }
  }

  async _playChime() {
    if (!this._playing) return;
    await playFile(CHIME_URL, () => { if (this._onError) this._onError(); });
    if (!this._playing) return;
    const u = getUrgency(this._currentOrders);
    if (!u) { this._playing = false; return; }
    this._nextTimer = setTimeout(() => this._playChime(), u.pause);
  }

  _startLoop() {
    if (this._playing) return;
    if (!this._isEnabled()) return;
    if (!getUrgency(this._currentOrders)) return;
    this._playing = true;
    this._playChime();
  }

  _stopLoop() {
    if (!this._playing) return;
    this._clearTimer();
    this._playing = false;
  }

  _evaluate(orders) {
    this._currentOrders = orders;
    if ((orders && orders.new && orders.new.length || 0) > 0) {
      this._startLoop();
    } else {
      this._stopLoop();
    }
  }

  unlockOnGesture() {
    if (this._unlocked) return;
    this._unlocked = true;
    try {
      const audio = new Audio(CHIME_URL);
      audio.volume = 0;
      audio.play().catch(() => {});
    } catch {}
  }

onError(cb) { this._onError = cb; }

  startDataSync() {
    if (this._syncStarted) return;
    this._syncStarted = true;
    this._unsubscribe = dataSyncService.subscribe('orders', (orders) => {
      this._evaluate(orders);
    });
    const current = dataSyncService.getData('orders');
    if (current) this._evaluate(current);
    window.addEventListener('storage', this._onStorageChange);
  }

  _onStorageChange(e) {
    if (e.key !== SOUND_KEY) return;
    const current = dataSyncService.getData('orders');
    if (current) this._evaluate(current);
  }

  reEvaluate() {
    const current = dataSyncService.getData('orders');
    if (current) this._evaluate(current);
    if (!this._isEnabled()) this._stopLoop();
  }

  playOnce() {}
  handleOrderEvent() {}

  stop() {
    this._clearTimer();
    this._stopLoop();
    if (this._unsubscribe) { this._unsubscribe(); this._unsubscribe = null; }
    window.removeEventListener('storage', this._onStorageChange);
    this._syncStarted = false;
  }
}

const soundService = new SoundService();
export default soundService;
